<template>
  <div>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="setErrorZero">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar flat color="white">
      <v-toolbar-title>Balance Withdraw Request Pending</v-toolbar-title>
      <!-- <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider> -->
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
        align="center"
        @keyup.enter="paginationMethod"
      ></v-text-field>
      <v-spacer></v-spacer>
      <!-- view page start here -->
      <v-dialog v-model="dialog">
        <template>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-card>
                <v-card-text>
                  <v-card-title class="indigo white--text">
                    <div class="headline">Withdraw request detail</div>
                  </v-card-title>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular"
                        ><b>Amount:</b></v-subheader
                      >
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">{{
                        editedItem.amount
                      }}</v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular"
                        ><b>Account holder name:</b></v-subheader
                      >
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">{{
                        editedItem.account_holder_name
                      }}</v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular"
                        ><b>Withdraw method name:</b></v-subheader
                      >
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">{{
                        editedItem.withdraw_method_name
                      }}</v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular"
                        ><b>Account number:</b></v-subheader
                      >
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">{{
                        editedItem.account_number
                      }}</v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row v-if="editedItem.withdraw_method_id == 1">
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular"
                        ><b>Bank name:</b></v-subheader
                      >
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">{{
                        editedItem.bank_name
                      }}</v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row v-if="editedItem.withdraw_method_id == 1">
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular"
                        ><b>Branch name:</b></v-subheader
                      >
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">{{
                        editedItem.branch_name
                      }}</v-subheader>
                    </v-flex>
                  </v-layout>
                  <v-layout row v-if="editedItem.withdraw_method_id == 1">
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular"
                        ><b>Routing number:</b></v-subheader
                      >
                    </v-flex>
                    <v-flex xs6>
                      <v-subheader class="black--text font-weight-regular">{{
                        editedItem.routing_number
                      }}</v-subheader>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <v-list-tile-title class="font-weight-bold text-sm-center">
                Rejection Comments
              </v-list-tile-title>
              <v-layout row justify-space-around>
                <v-flex xs12>
                  <v-card>
                    <v-card-text class="px-1">
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-textarea
                          v-model="commentData.comment"
                          :rules="[(v) => !!v || 'This field is required']"
                          label="Comment here, why are you rejecting this request?"
                          box
                          required
                        ></v-textarea>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
          <!-- <v-divider inset></v-divider> -->
          <v-container fluid>
            <v-layout row>
              <div>
                <v-btn color="success" @click="verifyItem(editedItem)">
                  Accept
                </v-btn>
                <v-btn color="warning" @click="rejectItem(editedItem)">
                  Reject
                </v-btn>
                <v-btn color="red" @click="close">Close</v-btn>
              </div>
            </v-layout>
          </v-container>
        </template>
      </v-dialog>
      <!-- view page end here -->
    </v-toolbar>
    <div v-if="isLoaded">
      <div v-if="alertMsg">
        <v-alert
          v-if="error == 0 && statusCode == 200"
          :value="true"
          type="success"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && statusCode == 204"
          :value="true"
          type="info"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && (statusCode == 403 || statusCode == 400)"
          :value="true"
          type="warning"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
        <v-alert
          v-if="error == 1 && statusCode == 500"
          :value="true"
          type="error"
          transition="slide-y-reverse-transition"
        >
          {{ errorMsg }}
        </v-alert>
      </div>
      <div v-if="indexData.total < 1" class="text-xs-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </div>
      <v-data-table
        :headers="headers"
        :items="indexData.balanceWithDrawStatus1.data"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :loading="loading"
        class="elevation-1"
      >
        <v-progress-linear color="blue" indeterminate></v-progress-linear>
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span v-on="on">
                {{ props.header.text }}
              </span>
            </template>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>

        <template v-if="indexData.total > 0" v-slot:items="props">
          <td>{{ props.item.id }}</td>
          <td class="text-xs-center">{{ props.index + 1 }}</td>
          <td class="text-xs-center">{{ props.item.amount }}</td>
          <td class="text-xs-center">{{ props.item.account_number }}</td>
          <td class="text-xs-center">{{ props.item.account_holder_name }}</td>
          <td class="text-xs-center">{{ props.item.withdraw_status_name }}</td>
          <td class="text-xs-center">{{ props.item.withdraw_method_name }}</td>
          <td class="justify-center layout px-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="mr-2"
                  v-on="on"
                  @click="checkItem(props.item)"
                >
                  visibility
                </v-icon>
              </template>
              <span>view</span>
            </v-tooltip>
          </td>
        </template>
        <template v-else v-slot:no-data>
          <v-alert :value="true" color="error" icon="warning">
            {{ errorMsg }}
          </v-alert>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
        <template v-slot:pageText>
          Rows {{ indexData.balanceWithDrawStatus1.from }} -
          {{ indexData.balanceWithDrawStatus1.to }} of
          {{ indexData.balanceWithDrawStatus1.total }}
        </template>
      </v-data-table>
      <template>
        <div class="text-xs-center">
          <v-layout wrap>
            <v-flex xs10 sm10 md10>
              <v-pagination
                right
                v-model="indexData.balanceWithDrawStatus1.current_page"
                :length="indexData.balanceWithDrawStatus1.last_page"
                @input="onPageChange"
              ></v-pagination>
            </v-flex>
          </v-layout>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data: () => ({
    dialog: false,
    alertMsg: false,
    apiUrl: "balance-withdraw-status",
    valid: true,
    sl: 1,
    headers: [
      { text: "ID", align: "left", value: "id" },
      { text: "Amount", align: "center", value: "amount", sortable: true },
      {
        text: "Account Number",
        align: "center",
        value: "account_number",
        sortable: true,
      },
      {
        text: "Account Holder Name",
        align: "center",
        value: "account_holder_name",
        sortable: true,
      },
      { text: "Status", align: "center", value: "Status", sortable: true },
      {
        text: "Withdraw Method",
        align: "center",
        value: "withdraw_method",
        sortable: true,
      },
      { text: "Actions", align: "center", value: "actions" },
    ],
    loading: false,
    search: "",
    pagination: {
      rowsPerPage: 10,
    },
    rowsPerPageItems: [10, 20, 50, 100, 200, 500],
    editedIndex: -1,
    editedItem: {},
    commentData: {
      id: null,
      comment: null,
    },
    defaultItem: {
      rowsPerPage: 10,
    },
  }),

  computed: {
    ...mapGetters([
      "isLoggedIn",
      "indexData",
      "error",
      "statusCode",
      "errorMsg",
    ]),
    isLoaded() {
      if (this.indexData.balanceWithDrawStatus1) {
        return true;
      } else {
        return false;
      }
    },
  },

  watch: {
    pagination() {
      this.onPageChange();
    },
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    this.reloading();
  },

  methods: {
    reloading() {
      this.$store.dispatch("changeBalanceWithdrawStatus", [
        this.apiUrl,
        1,
        "",
        1,
        this.pagination.rowsPerPage,
      ]);
    },
    initialize() {
      this.paginationMethod();

      // this.alertMsg = true
      // setTimeout(() => {
      //   this.alertMsg = false
      // }, 300)
    },

    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },

    // search(){
    //   console.log(this.search);
    // },

    checkItem(item) {
      this.commentData.id = null;
      this.commentData.comment = null;
      this.editedIndex =
        this.indexData.balanceWithDrawStatus1.data.indexOf(item);
      this.editedItem = Object.assign([], item);
      this.dialog = true;
    },

    verifyItem(item) {
      // console.log(item)
      var popUpMsg = confirm("Are you sure want to accept this application?");
      if (popUpMsg) {
        this.$store.dispatch("changeBalanceWithdrawStatus", [
          "balance-withdraw-accept",
          1,
          "",
          1,
          this.pagination.rowsPerPage,
          item.id,
        ]);
      }
      this.reloading();
      this.close();
    },

    rejectItem(item) {
      this.commentData.id = item.id;
      // console.log(this.commentData);
      if (this.$refs.form.validate()) {
        var popUpMsg = confirm("Are you sure want to reject this application?");
        if (popUpMsg) {
          this.$store.dispatch("updateRequest", [
            "balance-withdraw-reject",
            this.commentData,
          ]);
        }
        this.reloading();
        this.close();
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    onPageChange() {
      this.paginationMethod();
    },

    paginationMethod() {
      this.loading = true;
      if (this.search) {
        this.pagination.rowsPerPage = 1000;
        this.$store.dispatch("changeBalanceWithdrawStatus", [
          this.apiUrl,
          1,
          this.search,
          this.indexData.balanceWithDrawStatus1.current_page,
          this.pagination.rowsPerPage,
          "",
        ]);
        this.loading = this.indexData.balanceWithDrawStatus1.data
          ? false
          : true;
      } else {
        if (this.pagination.rowsPerPage == 1000) {
          this.pagination.rowsPerPage = 10;
        }
        this.$store.dispatch("changeBalanceWithdrawStatus", [
          this.apiUrl,
          1,
          "",
          this.indexData.balanceWithDrawStatus1.current_page,
          this.pagination.rowsPerPage,"",
        ]);
        this.loading = !this.indexData.balanceWithDrawStatus1.error
          ? false
          : true;
      }
      this.dialog = false;
    },
  },
};
</script>
<style lang="stylus" scoped>
.v-progress-circular
  margin: 1rem

.imageResize
  width: auto
  height: auto
</style>
